var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Modal',{attrs:{"showModal":_vm.showLoader}},[_c('b-spinner',{attrs:{"variant":"light","label":"Spinning"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }